// import React from "react";
// import { BrowserRouter, Routes, Route,Navigate } from "react-router-dom";
// import Sidebar from "./Components/Sidebar";
// import Dashboard from "./Components/Dashboard";
// import Signup from "./Components/Signup";
// import Login from "./Components/Login";
// import ContractManagement from "./Components/ContractManagement";
// import ContributionPage from "./Components/ContributionPage";
// import DiscoverPage from "./Components/DiscoverPage";
// import FAQPage from "./Components/FAQPage";
// import KYCPage from "./Components/KYCPage";
// import ProjectsPage from "./Components/ProjectsPage";
// import Report from "./Components/Report";
// import Settings from "./Components/Settings";
// import UserDetails from "./Components/UserDetails";
// import ProjectFullView from "./Components/ProjectFullView ";
// import CreateProject from "./Components/CreateProject";
// import Terms from "./Components/Terms";a
// import PrivacyPolicy from "./Components/PrivacyPolicy";
// import ForgotPassword from "./Components/ForgotPassword";
// import ResetPassword from "./Components/ResetPassword";
// import Updates from "./Components/Updates";

// function App() {
//   return (

//     <BrowserRouter>
//       <div>

//         <Routes>
//           <Route path="/login" element={<Login />} />
//           <Route path="/" element={<Navigate to="/login" />} />
//           <Route path="/signup" element={<Signup />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/sidebar" element={<Sidebar />} />
//           <Route path="/contracts" element = {<ContractManagement/>}/>
//           <Route path="/contribution" element = {<ContributionPage/>}/>
//           <Route path="/discover" element = {<DiscoverPage/>}/>
//           <Route path="/faq" element = {<FAQPage/>}/>
//           <Route path="/kyc" element = {<KYCPage/>}/>
//           <Route path="/project" element = {<ProjectsPage/>}/>
//           <Route path="/report" element = {<Report/>}/>
//           <Route path="/setting" element = {<Settings/>}/>
//           <Route path="/user" element = {<UserDetails/>}/>
//           {/* <Route path="/projectFullView" element = {<ProjectFullView/>}/> */}
//           <Route path="/createProject" element = {<CreateProject/>}/>
//           <Route path="/Terms" element = {<Terms/>}/>
//           <Route path="/Privacy" element = {<PrivacyPolicy/>}/>
//           <Route path="/fargotPassword" element = {<ForgotPassword/>}/>
//           <Route path="/reset-password" element={<ResetPassword />} />
//           <Route path="/projects/:id" element={<ProjectFullView />} />
//           <Route path='/updates' element={<Updates/>} />

//         </Routes>
//       </div>
//     </BrowserRouter>
//   );
// }

// export default App;









import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Import all your components
import Sidebar from "./Components/Sidebar";
import Dashboard from "./Components/Dashboard";
import Signup from "./Components/Signup";
import Login from "./Components/Login";
import ContractManagement from "./Components/ContractManagement";
import ContributionPage from "./Components/ContributionPage";
import FAQPage from "./Components/FAQPage";
import ProjectsPage from "./Components/ProjectsPage";
// import Report from "./Components/Report";
import Settings from "./Components/Settings";
import UserDetails from "./Components/UserDetails";
import CreateProject from "./Components/CreateProject";
import Terms from "./Components/Terms";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import ForgetPassword from "./Components/ForgetPassword";
import ResetPassword from "./Components/ResetPassword";
import Updates from "./Components/Updates";
import ProtectedRoute from "./Components/ProtectedRoute";
import ContributorContract from "./Components/ContributorContract";
import ProjectFullView from "./Components/ProjectFullView ";
import ProjectPage from "./Components/ProjectPage";
import DiscoverPage from "./Components/DiscoverPage";
import KYCPage from "./Components/KYCPage";
import TransactionHistory from "./Components/TransactionHistory";
import ContractsListPage from "./Components/ContractsListPage";
import ContributedProjects from "./Components/ContributedProjects";
import BlogView from "./Components/BlogView";
import ReferralRedirect from "./Components/ReferralRedirect";
// import ProjectPage from "./Components/DetailPage/ProjectPage";


function App() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) sessionStorage.setItem("referralCode", ref);
  }, []);

  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          {/* Public Routes - Accessible to all users */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/Privacy" element={<PrivacyPolicy />} />
          <Route path="/full-view" element={<ProjectFullView />} />
          <Route path="/r/:code" element={<ReferralRedirect />} />
          {/* Private Routes - Only accessible to authenticated users */}
          <Route
            path="/dashboard"
            element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
          />
          <Route
            path="/sidebar"
            element={<ProtectedRoute><Sidebar /></ProtectedRoute>}
          />
          <Route
            path="/contracts"
            element={<ProtectedRoute><ContractManagement /></ProtectedRoute>}
          />
          <Route
            path="/contribution"
            element={<ProtectedRoute><ContributionPage /></ProtectedRoute>}
          />
          <Route
            path="/discover"
            element={<ProtectedRoute><DiscoverPage /></ProtectedRoute>}
          />
          <Route
            path="/faq"
            element={<ProtectedRoute><FAQPage /></ProtectedRoute>}
          />
          <Route
            path="/kyc"
            element={<ProtectedRoute><KYCPage /></ProtectedRoute>}
          />
          <Route
            path="/project"
            element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>}
          />
          <Route
            path="/project/:id/:title"
            element={<ProtectedRoute><ProjectPage /></ProtectedRoute>}
          />
          
          
          <Route path="/contracts-list" element={<ContractsListPage />} />
          <Route
            path="/transaction-history"
            element={<ProtectedRoute><TransactionHistory /></ProtectedRoute>}
          />
          <Route
            path="/setting"
            element={<ProtectedRoute><Settings /></ProtectedRoute>}
          />
          <Route
            path="/user"
            element={<ProtectedRoute><UserDetails /></ProtectedRoute>}
          />
          <Route
            path="/createProject"
            element={<ProtectedRoute><CreateProject /></ProtectedRoute>}
          />
          <Route
            path="/contributor-contract"
            element={<ProtectedRoute><ContributorContract /></ProtectedRoute>}
          />
          <Route path="/project/contributed/:projectId" element={<ContributedProjects />} />
          <Route
            path="/updates"
            element={<ProtectedRoute><Updates /></ProtectedRoute>}
          />
          <Route
            path="/updates/:id"
            element={<ProtectedRoute><BlogView /></ProtectedRoute>}
          /><Route
            path="/updates/:id/:title"
            element={<ProtectedRoute><BlogView /></ProtectedRoute>}
          />
          {/* <Route path="/updates/:id" element={<BlogView />} />
          <Route path="/updates/:id/:title" element={<BlogView />} /> */}

        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
